// The active workspace's plan at a glance (simple-mode S4), from GET /entitlements only:
// plan name, one-time credits on a credits plan (Free), or this month's calls on a
// monthly plan, and the counted limits (seats, apps, triggers). No prices (billing does
// not exist).
import type { Entitlements } from '../api/types'
import { creditsState, planName } from './index'

/** `used of limit` for an int limit (null = unlimited, absent = not in the plan). */
function limitText(used: number | undefined, raw: unknown): string {
  const u = used ?? 0
  if (raw === null) return `${u} (unlimited)`
  if (typeof raw !== 'number') return 'Not included'
  return `${u} of ${raw}`
}

export function PlanSummary({ ent }: { ent: Entitlements }) {
  const credits = creditsState(ent)
  const f = (k: string) => ent.features[k]?.value
  const seats = typeof ent.usage.seats === 'number' ? ent.usage.seats : ent.usage.members
  return (
    <dl className="plan-usage" aria-label="Plan usage">
      <div>
        <dt>Plan</dt>
        <dd data-testid="plan-name">{planName(ent)}</dd>
      </div>
      {credits ? (
        <div>
          <dt>Free credits left</dt>
          <dd data-testid="credits-balance">
            {credits.granted > 0 ? `${credits.balance} of ${credits.granted}` : String(credits.balance)}
            {credits.exhausted ? ' (tool calls paused)' : ''}
          </dd>
        </div>
      ) : (
        <div>
          <dt>Tool calls this month</dt>
          <dd>{limitText(ent.usage.calls_month, f('calls.monthly'))}</dd>
        </div>
      )}
      <div>
        <dt>Seats (members and pending invites)</dt>
        <dd>{limitText(seats, f('members.max'))}</dd>
      </div>
      <div>
        <dt>Connected apps</dt>
        <dd>{limitText(ent.usage.apps, f('apps.max'))}</dd>
      </div>
      <div>
        <dt>Triggers</dt>
        <dd>{limitText(ent.usage.triggers, f('triggers.max'))}</dd>
      </div>
    </dl>
  )
}
